import {
  type AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from "@backstage/core-plugin-api";
import {
  ScmAuth,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from "@backstage/integration-react";
import {
  ExplorerClient,
  explorerApiRef,
} from "@prisamedia/plugin-cloudhealth-explorer";

import { isAppProxyActive } from "./appProxy";

export const apis: AnyApiFactory[] = [
  // Cuando el acceso es vía Azure AD Application Proxy (flag
  // app.oauth2ProxyEnabled y origin igual al app.baseUrl público del
  // entorno), las llamadas API deben ir al mismo origen para que las
  // cabeceras de identidad inyectadas por el proxy se mantengan en cada
  // petición. Con el flag off o con otro origin, discovery usa el
  // backend.baseUrl configurado.
  createApiFactory({
    api: discoveryApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => {
      const baseUrl = isAppProxyActive(configApi, window.location.origin)
        ? window.location.origin
        : configApi.getString("backend.baseUrl");
      return {
        async getBaseUrl(pluginId: string) {
          return `${baseUrl}/api/${pluginId}`;
        },
      };
    },
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: explorerApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new ExplorerClient({ discoveryApi, fetchApi }),
  }),
];
